import { api } from '../lib/api';

export interface KanbanStats {
  id: string;
  nome: string;
  descricao: string;
  cor: string;
  isDefault: boolean;
  createdAt: string;
  updatedAt: string;
  estatisticas: {
    totalTitulos: number;
    titulosAbertos: number;
    titulosVencidos: number;
    titulosParciais: number;
    titulosFechados: number;
    titulosCancelados: number;
    valorTotal: number;
    valorAberto: number;
    valorVencido: number;
    valorParcial: number;
    valorFechado: number;
    valorCancelado: number;
    taxaRecuperacao: number;
    operadoresAtivos: number;
    totalClientes: number;
    clientesAbertos: number;
    clientesVencidos: number;
    clientesParciais: number;
    clientesFechados: number;
    clientesCancelados: number;
  };
  etapas: Array<{
    id: string;
    nome: string;
    cor: string;
    ordem: number;
    titulosCount: number;
    valorTotal: number;
    clientesCount: number;
  }>;
}

export interface KanbanStatsResponse {
  success: boolean;
  data: {
    kanbans: KanbanStats[];
    resumoGeral: {
      totalKanbans: number;
      totalTitulos: number;
      totalValor: number;
      totalOperadores: number;
    };
    filtros: {
      companyId?: string;
      operadorId?: string;
      period?: string;
    };
  };
}

export const kanbanStatsService = {
  async getKanbanStats(filters?: {
    companyId?: string;
    operadorId?: string;
    period?: string;
  }): Promise<KanbanStatsResponse> {
    const params = new URLSearchParams();
    
    if (filters?.companyId) {
      params.append('companyId', filters.companyId);
    }
    if (filters?.operadorId) {
      params.append('operadorId', filters.operadorId);
    }
    if (filters?.period) {
      params.append('period', filters.period);
    }

    const response = await api.get(`/reports/kanban-stats?${params.toString()}`);
    return response.data;
  }
};
